<div class="main">
  <!-- First Row -->
  <div class="row">
    <div class="col-md-6">
      <div class="row" 
      *ngFor="let card of KTL" 
      [ngStyle]="
      {
        'background-color': card.backgroundColor, 
        'border-radius': '10px'
      }">
        <div class="row-content">
          <div class="card-content mr-4 ml-4">
            <div class="card-image-wrapper">
              <img class="card-image" [src]="card.imgSrc">
            </div>
            <div class="card-footer-text">
              {{ card.footerText }}
            </div>
          </div>
            <div 
            *ngFor="let card of card.children" 
            [id]="card.id" 
            class="card-classes mr-4 mx-auto"
            (click)="navigateTo(card.navigateTo)">
              <mat-card 
              class="square-card mt-5 mb-5 mr-2"
              [style.cursor]="card.cursor"
              matRipple 
              [ngStyle]="
              {
                'background-color': card.backgroundColor,
                'margin-left': '10px',
                'margin-right': '10px'
              }"> 
                <div class="card-content">
                  <img class="card-image" 
                  [src]="card.imgSrc" 
                  [ngStyle]="
                  {
                    'width': (
                      card.class === 'FlareKTL' || 
                      card.class === 'FuelKTL') ? '35px' : '90px', 
                    'height': (
                      card.class === 'FlareKTL') ? '70px' : 
                      (card.class === 'FuelKTL') ? '50px' : '90px'
                  }">
                </div>
                <mat-divider></mat-divider>
                <mat-card-footer class="card-footer">
                  {{ card.footerText }}
                </mat-card-footer>
              </mat-card>
            </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row" 
      *ngFor="let card of FieldAndLPG" 
      [ngStyle]="
      {
        'background-color': card.backgroundColor, 
        'border-radius': '10px'
      }">
        <div class="row-content">
          <div class="card-content mx-4">
            <div class="card-image-wrapper">
              <img class="card-image" [src]="card.imgSrc">
            </div>
            <div class="card-footer-text" style="margin-right: 30px;">
              {{ card.footerText }}
            </div>
          </div>
            <div 
            *ngFor="let card of card.children" 
            [id]="card.id" 
            class="card-classes mr-4 mx-auto"
            (click)="navigateTo(card.navigateTo)">
              <mat-card 
              class="square-card mt-5 mb-5 mx-2"
              [style.cursor]="card.cursor"
              matRipple 
              [ngStyle]="
              {
                'background-color': card.backgroundColor,
                'margin-left': '10px',
                'margin-right': '10px'
              }"> 
                <div class="card-content">
                  <img class="card-image" 
                  [src]="card.imgSrc" 
                  [ngStyle]="
                  {
                    'width': '90px', 
                    'height': '90px'
                  }">
                </div>
                <mat-divider></mat-divider>
                <mat-card-footer class="card-footer">
                  {{ card.footerText }}
                </mat-card-footer>
              </mat-card>
            </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Second Row -->
  <div class="row">
    <div class="col-md-6">
      <div class="row" 
      *ngFor="let card of SGP" 
      [ngStyle]="
      {
        'background-color': card.backgroundColor, 
        'border-radius': '10px'
      }">
        <div class="row-content">
          <div class="card-content mr-4 ml-4">
            <div class="card-image-wrapper">
              <img class="card-image" [src]="card.imgSrc">
            </div>
            <div class="card-footer-text">
              {{ card.footerText }}
            </div>
          </div>
            <div 
            *ngFor="let card of card.children" 
            [id]="card.id" 
            class="card-classes mr-4 mx-auto"
            (click)="navigateTo(card.navigateTo)">
              <mat-card 
              class="square-card mt-5 mb-5 mr-2"
              [style.cursor]="card.cursor"
              matRipple 
              [ngStyle]="
              {
                'background-color': card.backgroundColor,
                'margin-left': '10px',
                'margin-right': '10px'
              }"> 
                <div class="card-content">
                  <img class="card-image" 
                  [src]="card.imgSrc" 
                  [ngStyle]="
                  {
                    'width': (
                      card.class === 'FlareSGP' || 
                      card.class === 'FuelSGP') ? '35px' : '90px', 
                    'height': (
                      card.class === 'FlareSGP') ? '70px' : 
                      (card.class === 'FuelSGP') ? '50px' : '90px'
                  }">
                </div>
                <mat-divider></mat-divider>
                <mat-card-footer class="card-footer">
                  {{ card.footerText }}
                </mat-card-footer>
              </mat-card>
            </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row" 
      *ngFor="let card of IUSandSGI" 
      [ngStyle]="
      {
        'background-color': card.backgroundColor, 
        'border-radius': '10px'
      }">
        <div class="row-content">
          <div class="card-content mr-4 ml-4">
            <div class="card-image-wrapper">
              <img class="card-image" [src]="card.imgSrc">
            </div>
            <div class="card-footer-text">
              {{ card.footerText }}
            </div>
          </div>
            <div 
            *ngFor="let card of card.children" 
            [id]="card.id" 
            class="card-classes mr-4 mx-auto"
            (click)="navigateTo(card.navigateTo)">
              <mat-card 
              class="square-card mt-5 mb-5 mr-2"
              [style.cursor]="card.cursor"
              matRipple 
              [ngStyle]="
              {
                'background-color': card.backgroundColor,
                'margin-left': '10px',
                'margin-right': '10px'
              }"> 
                <div class="card-content">
                  <img class="card-image" 
                  [src]="card.imgSrc" 
                  [ngStyle]="
                  {
                    'width': '90px', 
                    'height': '90px'
                  }">
                </div>
                <mat-divider></mat-divider>
                <mat-card-footer class="card-footer">
                  {{ card.footerText }}
                </mat-card-footer>
              </mat-card>
            </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Third Row -->
  <div class="row">
    <div class="col-md-6">
      <div class="row" 
      *ngFor="let card of ThreeGP" 
      [ngStyle]="
      {
        'background-color': card.backgroundColor, 
        'border-radius': '10px'
      }">
        <div class="row-content">
          <div class="card-content mr-4 ml-4">
            <div class="card-image-wrapper">
              <img class="card-image" [src]="card.imgSrc">
            </div>
            <div class="card-footer-text">
              {{ card.footerText }}
            </div>
          </div>
            <div 
            *ngFor="let card of card.children" 
            [id]="card.id" 
            class="card-classes mr-4 mx-auto"
            (click)="navigateTo(card.navigateTo)">
              <mat-card 
              class="square-card mt-5 mb-5 mr-2"
              [style.cursor]="card.cursor"
              matRipple 
              [ngStyle]="
              {
                'background-color': card.backgroundColor,
                'margin-left': '10px',
                'margin-right': '10px'
              }"> 
                <div class="card-content">
                  <img class="card-image" 
                  [src]="card.imgSrc" 
                  [ngStyle]="
                  {
                    'width': (
                      card.class === 'Flare3GP' || 
                      card.class === 'Fuel3GP') ? '35px' : '90px', 
                    'height': (
                      card.class === 'Flare3GP') ? '70px' : 
                      (card.class === 'Fuel3GP') ? '50px' : '90px'
                  }">
                </div>
                <mat-divider></mat-divider>
                <mat-card-footer class="card-footer">
                  {{ card.footerText }}
                </mat-card-footer>
              </mat-card>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>